import { Button, CircularProgress, IconButton, Stack, Typography } from '@mui/material';
import { colours } from "../../../StyleConstants";
import LassoModal from "../../../components/LassoModal";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import React, { useEffect } from "react";
import { useDeleteDUCMutation, useGetDUCInfoQuery } from '../../../api/ducApiSlice';
import { useUserInfoQuery } from '../../../api/userApiSlice';

const DUCDeleteModal = ({ open, setOpen, type, cancelRefresh }: any) => {
    const { data: userData } = useUserInfoQuery({});
    const { data: ducData, refetch } = useGetDUCInfoQuery({ email: userData['email'] });
    const [deleteDUC, { isLoading }] = useDeleteDUCMutation();
    const oldStatus = localStorage.getItem('status')

    useEffect(() => {
        refetch()
    }, [cancelRefresh]);


    useEffect(() => {

        if(type === "GENERAL"){
            if(ducData?.GENERAL?.[1]){
                if(ducData?.GENERAL?.[1]?.status !== oldStatus){
                    setOpen(false)
                }
            }
            else{
                if(ducData?.GENERAL?.[0]?.status !== oldStatus){
                    setOpen(false)
                }
            }
        }
        else{
            if(ducData?.AIAN?.[1]){
                if(ducData?.AIAN?.[1]?.status !== oldStatus){
                    setOpen(false)
                }
            }
            else{
                if(ducData?.AIAN?.[0]?.status !== oldStatus){
                    setOpen(false)
                }
            }
        }
    }, [ducData]);

    const handleCancelDUC = () => {
    // setLoading(true)
        if(type === "GENERAL"){
            if(ducData?.GENERAL?.[1]){
                deleteDUC({ id: ducData?.GENERAL?.[1]?.ducDetailsId }).then(() => {
                    setOpen(false);
                })
            }
            else{
                deleteDUC({ id: ducData?.GENERAL?.[0]?.ducDetailsId }).then(() => {
                    setOpen(false);
                })
            }
        }
        else{
            if(ducData?.AIAN?.[1]){
                deleteDUC({ id: ducData?.AIAN?.[1]?.ducDetailsId }).then(() => {
                    setOpen(false);
                })
            }
            else{
                deleteDUC({ id: ducData?.AIAN?.[0]?.ducDetailsId }).then(() => {
                    setOpen(false);
                })
            }
        }

    }

    return (
        <LassoModal open={open} onClose={() => setOpen(false)}>
            {!isLoading &&
          <Stack gap={4} padding="10px">
              <Stack flexDirection="row" justifyContent="space-between">
                  <Typography variant="h3"  fontSize="20px" fontWeight="600">
                Are you sure you want to cancel your DUC request?
                  </Typography>
                  <IconButton aria-label="Close cancel DUC request dialog" onClick={() => {setOpen(false)}} sx={{ position: "absolute", top: 0, right: 0 }}>
                      <HighlightOffIcon/>
                  </IconButton>
              </Stack>
              <Typography color={colours.midnightBlue.blue}>
                  <strong>Please note:</strong> If you cancel, you'll need to restart the entire DUC process from scratch, including obtaining all required signatures again. This action cannot be undone.
              </Typography>

              <Stack flexDirection="row" alignSelf="center" gap={2}>
                  <Button variant="tertiary" onClick={() => setOpen(false)} sx={{ fontWeight: 600 }}>
                No, Keep My DUC Request and Do NOT Cancel
                  </Button>
                  <Button variant="primary" onClick={handleCancelDUC}>
                Yes, Cancel My DUC Request
                  </Button>
              </Stack>
          </Stack>
            }
            {isLoading && <CircularProgress/>}

        </LassoModal>
    )
}

export default DUCDeleteModal;